import { render } from "./PreCourtDetails.vue?vue&type=template&id=2f7bb36c&scoped=true"
import script from "./PreCourtDetails.vue?vue&type=script&lang=js"
export * from "./PreCourtDetails.vue?vue&type=script&lang=js"

import "./PreCourtDetails.vue?vue&type=style&index=0&id=2f7bb36c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7bb36c"]])

export default __exports__